import React from 'react';

function Deals() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_428_156678"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="21"
        height="22"
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M4 4H24.8708V25.844H4V4Z" fill="white" />
      </mask>
      <g mask="url(#mask0_428_156678)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0028 18.5575L14.0884 19.6141L13.4723 20.2283L12.637 19.3929C12.5685 19.3244 12.4759 19.2862 12.3794 19.2862H5.45728V18.5575H14.0028ZM4.7287 17.1003C4.73052 15.4914 6.03443 14.1875 7.64327 14.1857H13.4724C13.5322 14.1857 13.5901 14.1919 13.6491 14.1955L13.7074 14.9143H13.1081V15.643H13.7664L13.9438 17.8289H4.7287V17.1003ZM14.201 11.6354H20.7588V9.44951H14.201V11.6354ZM21.4875 11.6354H23.6734V9.44951H21.4875V11.6354ZM22.6358 24.7801C22.6205 24.97 22.4621 25.1161 22.2715 25.1153H21.4875V15.2787H23.4064L22.6358 24.7801ZM14.467 15.2787H16.3869V25.1153H15.2656L14.467 15.2787ZM4.7287 23.2937H14.3869L14.5344 25.1153H8.37191V24.0224H7.64327V25.1153H6.91463V24.0224H6.18598V25.1153H4.7287V23.2937ZM5.45728 21.8364H14.2688L14.3278 22.5651H5.45728V21.8364ZM16.387 14.55H14.408L14.2306 12.3641H16.387V14.55ZM17.1156 14.55H18.5729V12.3641H17.1156V14.55ZM19.3014 14.55H20.7587V12.3641H19.3014V14.55ZM23.6425 12.3641L23.4654 14.55H21.4875V12.3641H23.6425ZM17.1156 25.1153H18.5729V15.2787H17.1156V25.1153ZM19.3014 25.1153H20.7587V15.2787H19.3014V25.1153ZM13.2148 21.001C13.3572 21.1435 13.5875 21.1435 13.7299 21.001L14.1671 20.5639L14.2094 21.1078H5.45728V20.0148H12.2286L13.2148 21.001ZM4.72864 21.4721V22.5651H4.36432C4.16322 22.5651 4 22.7279 4 22.9294V25.4796C4 25.6811 4.16322 25.844 4.36432 25.844H22.2725C22.8409 25.8411 23.313 25.4057 23.3622 24.8395L24.402 11.9998V9.08519C24.402 8.88409 24.2391 8.72087 24.0377 8.72087H21.4874V5.71304L24.8709 4.69804L24.6617 4L21.0185 5.09296C20.8644 5.13923 20.7588 5.28095 20.7588 5.44198V8.72087H13.8367C13.6356 8.72087 13.4724 8.88409 13.4724 9.08519V11.9998V12.0049V12.0293L13.5886 13.4636C13.5492 13.4636 13.511 13.457 13.4713 13.457H7.64321C5.63179 13.4592 4.00219 15.0888 4 17.1003V18.1932C4 18.3947 4.16322 18.5575 4.36432 18.5575H4.72864V21.4721Z"
          fill="black"
        />
      </g>
      <mask
        id="mask1_428_156678"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="21"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 25.844H24.8709V4H4V25.844Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_428_156678)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1936 15.643H10.9222V14.9143H10.1936V15.643Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.73621 16.3716H9.46485V15.643H8.73621V16.3716Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6509 16.3716H12.3795V15.643H11.6509V16.3716Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.27893 15.643H8.00757V14.9143H7.27893V15.643Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export default Deals;
